<template>
  <div>
    <h4>
      <img style="margin-right: 5px" src="@/img/star234.png" alt="" /> 门店地址
    </h4>
    <div style="padding: 10px 30px">
      <el-card class="box-card">
        <div class="text">
          <p>自有光·深圳罗湖店</p>
          <p>广东省深圳市罗湖区人民南路佳宁娜广场 3楼整层</p>
        </div>
      </el-card>
    </div>
    <h4>
      <img style="margin-right: 5px" src="@/img/star234.png" alt="" />
      选择到店日期
    </h4>
    <div>
      <section class="content">
        <div
          v-for="(value, index) in time"
          :key="index"
          @click="liClick(value.appointmentTime)"
          :class="{ active: currentIndex === value.appointmentTime }"
          class="item"
        >
          <span>{{ value.week }}</span> <br />
          <span>{{ value.date }}</span>
        </div>
      </section>
    </div>
    <h4>
      <img style="margin-right: 5px" src="@/img/star234.png" alt="" />
      选择时间段
    </h4>
    <div>
      <section class="content2">
        <div v-for="(value, index) in timeSlot" :key="index">
          <div v-if="value <= 0">
            <button class="item2" style="background-color: #eee">
              <div v-if="[Number(index)] <= 24">
                上午(约满)<br />
                {{ Math.floor(index / 2) }}:{{
                  Number(index) % 2 == 0 ? "00" : "30"
                }}-{{ Math.ceil(index / 2) }}:{{
                  Number(index) % 2 == 0 ? "30" : "00"
                }}
              </div>
              <div v-if="[index] > 24">
                下午(约满)<br />{{ Math.floor(index / 2) }}:{{
                  Number(index) % 2 == 0 ? "00" : "30"
                }}-{{ Math.ceil(index / 2) }}:{{
                  Number(index) % 2 == 0 ? "30" : "00"
                }}
              </div>
            </button>
          </div>
          <div v-else>
            <button
              @click="clickTime(index)"
              class="item2"
              :style="start == index ? 'background-color:#00e567' : ''"
            >
              <div v-if="[Number(index) - 1] < 24">
                上午<br />{{ Math.floor(index / 2) }}:{{
                  Number(index) % 2 == 0 ? "00" : "30"
                }}-{{ Math.ceil(index / 2) }}:{{
                  Number(index) % 2 == 0 ? "30" : "00"
                }}
              </div>
              <div v-if="[index] > 24">
                下午<br />{{ Math.floor(index / 2) }}:{{
                  Number(index) % 2 == 0 ? "00" : "30"
                }}-{{ Math.ceil(index / 2) }}:{{
                  Number(index) % 2 == 0 ? "30" : "00"
                }}
              </div>
            </button>
          </div>
        </div>
      </section>
    </div>
    <h4>
      <img style="margin-right: 5px" src="@/img/star234.png" alt="" />
      姓名
    </h4>
    <div style="padding: 10px 30px">
      <el-input
        v-model="name"
        maxlength="6"
        placeholder="请输入您的名字"
      ></el-input>
    </div>
    <h4>
      <img style="margin-right: 5px" src="@/img/star234.png" alt="" />
      备注
      <span style="font-size: 14px; margin-left: 5px">
        如不方便电话确认预约，可预留微信</span
      >
    </h4>
    <div style="padding: 10px 30px">
      <el-input
        type="textarea"
        autosize
        maxlength="20"
        placeholder="请输入内容"
        v-model="textarea"
      >
      </el-input>
    </div>
    <div class="bottom">
      <p>提交预约后，我们将在30分钟内与您电话确认预约</p>
      <p>服务时间：09:00-19:00</p>
      <el-button @click.stop="sign" class="appointment">提交预约</el-button>
    </div>
  </div>
</template>
<script>
import {
  confirmAppointmentClinic1,
  getByIdOutpatientEnable,
} from "@/api/outpatient";

export default {
  components: {},
  data() {
    return {
      name: "",
      textarea: "",
      currentIndex:
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate(), // 记录日期的变量
      time: [{}],
      start: null,
      userPhone: "",
      timeSlot: {
        // 20: "-1",
        // 21: "-1",
        // 22: "-1",
        // 23: "-1",
        // 24: "-1",
        // 25: "-1",
        // 26: "-1",
        // 27: "-1",
        // 28: "-1",
        // 29: "-1",
        // 30: "-1",
        // 31: "-1",
        // 32: "-1",
        // 33: "-1",
        // 34: "1",
        // 35: "1",
        // 36: "1",
        // 37: "1",
      },
    };
  },
  mounted() {
    this.TimeDate();
    this.GetTime();
    this.userPhone = JSON.parse(localStorage.getItem("phone")); //获取本地数据
  },
  methods: {
    //日期数据
    TimeDate() {
      var leng = 15;
      var now = new Date();
      var nowTime = now.getTime();
      var oneDayTime = 24 * 60 * 60 * 1000;
      var timeArr = [];
      var timeStr = "";
      for (var i = 0; i < leng; i++) {
        //显示星期
        var ShowTime = nowTime + i * oneDayTime;
        //初始化日期时间
        var myDate = new Date(ShowTime);
        var year = myDate.getFullYear();
        var month = myDate.getMonth() + 1;
        var date = myDate.getDate();
        var str = "周" + "日一二三四五六".charAt(myDate.getDay());
        timeStr = year + "-" + month + "-" + date + "(" + str + ")";
        timeArr.push({
          week: str,
          date: date,
          appointmentTime: year + "-" + month + "-" + date,
        });
        this.time = timeArr;
      }
    },
    liClick(index) {
      this.currentIndex = index;
      console.log(this.currentIndex);
      var uresData = {
        day: this.currentIndex,
        id: "1007",
      };
      getByIdOutpatientEnable(uresData).then((res) => {
        this.timeSlot = res.data;
      });
    },
    GetTime() {
      var uresData = {
        day: this.currentIndex,
        id: "1007",
      };
      getByIdOutpatientEnable(uresData).then((res) => {
        this.timeSlot = res.data;
      });
    },
    //点击选择时间的事件
    clickTime(start) {
      console.log(start);
      this.start = start;
    },

    sign() {
      if (this.name == "") {
        this.$message({
          message: "姓名不能为空",
          type: "warning",
        });
        return;
      }
      if (this.start == null) {
        this.$message({
          message: "预约时间不能为空",
          type: "warning",
        });
        return;
      }
      var uresData = {
        userName: this.name,
        userPhone: this.userPhone,
        remark: this.textarea,
        appointmentTime: this.currentIndex,
        outpatientId: "1007",
        appointmentStart: this.start,
        appointmentEnd: (parseInt(this.start) + 1).toString(),
      };
      confirmAppointmentClinic1(uresData).then((res) => {
        localStorage.removeItem("phone");
        this.$router.push("/embed/success");
      });
    },
  },
};
</script>
<style scoped>
.box-card {
  border-radius: 18px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 2px rgba(50, 62, 72, 0.1);
}
.text {
  font-size: 14px;
}
p {
  margin: 5px 0;
}
h4 {
  padding: 0px 30px;
  margin: 20px 0 10px 0;
}
.content {
  overflow: hidden;
  overflow-x: auto;
  white-space: nowrap;
  padding-left: 30px;
  padding-right: 30px;
}
.content::-webkit-scrollbar {
  display: none;
}
.item {
  border-radius: 10px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 2px 2px rgba(50, 62, 72, 0.1);
  text-align: center;
  display: inline-block;
  background: #fff;
  margin: 10px;
  width: 50px;
  height: 68px;
  padding: 10px 0 5px 0;
  line-height: 24px;
  border: 1px solid #dcdfe6;
}
.content2 {
  overflow-y: auto;
  height: 150px;
  padding: 10px 30px;
  display: flex;
  flex-wrap: wrap;
}

.item2 {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 2px 2px rgba(50, 62, 72, 0.1);
  display: inline-block;
  background: #fff;
  margin: 4px;
  width: 97px;
  height: 64px;
  line-height: 24px;
  font-size: 13px;
  opacity: 1;
  border-radius: 18px;
  border: 1px solid #dcdfe6;
  padding: 0;
}
.el-input >>> .el-input__inner {
  border-radius: 10px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 2px rgba(50, 62, 72, 0.1);
}
.el-textarea >>> .el-textarea__inner {
  height: 90px !important;
  border-radius: 10px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 2px rgba(50, 62, 72, 0.1);
}

.appointment {
  width: 100%;
  font-size: 18px;
  border-radius: 191px;
  background: rgba(50, 62, 72, 1);
  color: rgba(0, 228, 103, 1);
  margin-top: 10px;
}
.bottom {
  text-align: center;
  padding: 20px 30px 50px 30px;
}
.bottom > p {
  font-size: 12px;
}
.active {
  background-color: rgba(0, 228, 103, 1);
}
.el-input >>> .el-input__inner {
  padding-left: 15px !important;
}
</style>
